module.exports = __webpack_public_path__ + "static/media/thumb_invoicy_cloud.093c363a.png";